import React, { useState } from 'react';

const TopicInput = ({ onSubmit }) => {
    const [topic, setTopic] = useState('');

    const handleInputChange = (event) => {
        setTopic(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (topic.trim()) {
            onSubmit(topic);
            setTopic('');
        }
    };

    return (
        <div className="topic-input">
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    value={topic}
                    onChange={handleInputChange}
                    placeholder="Enter your debate topic"
                    required
                />
                <button type="submit">Start Debate</button>
            </form>
        </div>
    );
};

export default TopicInput;